import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs/internal/observable/interval';
import { RestApiService } from 'src/app/core/api/rest-api.service';
import { SharedService } from 'src/app/core/api/shared.service';
import { AuthService } from 'src/app/core/common/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  itemsInCart: any;
  itemsInWishlist: any = 0;
  tableID: any;
  LoggedName: any;
  LoggedRole: any;
  role:any;
  restLangList: any = [];
  waitTimeList:string[]=["0","10","20","30","40","50","60"];
  selectedWaitTime:string="0";

  @ViewChild('alertModal') public alertModal!: TemplateRef<any>;
  private modalRef!: NgbModalRef;

  constructor(
    public _api: RestApiService,
    private router: Router,
    private _auth: AuthService,
    private _sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private sharedService:SharedService
  ) { }
  navigation_path_name: any
  ngOnInit(): void {
    this._auth.getRoleName.subscribe((item: any) => {
      this.role = item;
      this.getPropertyDetails();
    });
    this.aboutMe();
    interval(1000).subscribe(val => {
      this.getlocation()
    });


    this.getlang()
    let user = this._auth.user;
    if (!user.contact) {
      this.aboutMe();
    }
    this.setUser();

    this.getRestaurantData();

  }

  openAlertModal() {
    this.modalRef = this.modalService.open(this.alertModal, { centered: true });
  }
  closeModel() {
    this.modalRef?.close();
    this.alertMessage="";
  }

  setUser() {
    let user = this._auth.user;
    // console.log(user);
    
    this.LoggedName = user?.contact?.name;
    this.LoggedRole = user?.roleMaster ? user?.roleMaster[0]?.roleName : '';
  }

  getrestLanguage() {
    this._api.getrestLanguage({}).subscribe((data) => {

      this.restLangList = data.languageList;
    });
  }


  restcheck:any

  aboutMe() {
    this._api.aboutMe({}).subscribe((data) => {


      this.restcheck=data.restStatus

      this._auth.setUser(data.user);
      this.sharedService.setUser(data.user);
      this.setUser();
      // this._auth.login(data.user);
      this.getPropertyDetails();
      this._auth.setRestaurantId(data.restaurantId);
      this.getrestLanguage();
      this.checkWaitTime();
    });
  }


  itemImage: any = '';
  getPropertyDetails() {
    this._api.getPropertyList({}).subscribe((data) => {

      this.itemImage = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + data.propertyList[0].icon);

    });
  }

  // get added wait time from the db
  getRestaurantData(){
    let formData={
      restaurantId:localStorage.getItem('restaurantId'),
    }
    this._api.getRestaurant(formData).subscribe(data=>{
      this.selectedWaitTime=data.rest.waitTime;
    })
  }
  getlocation() {
    // this.navigation_path_name = window.location.href.split('/').pop();
    let locato = window.location.href.split('/').pop();
    if(locato){
      this.navigation_path_name= locato.replace('helpdesk', 'Help desk');
    }
  }
  checkWaitTime(){
    let formData = {
      "restaurantId": localStorage.getItem("restaurantId"),
    };
    this._api.getWaitTime(formData).subscribe(data=>{
      this.selectedWaitTime=data.waitTime;
      
    });
  }

  //Wait Time executes after any change form dropdown
  setWaitTime(event:any){

    let time=event.target.value || 0;
    this.selectedWaitTime=time;
    let formData={
      restaurantId:localStorage.getItem('restaurantId'),time:time
    }
    this._api.setWaitTime(formData).subscribe((data:any)=>{
      this.openAlertModal();
      this.alertMessage=data.message;
    })
  }

  toggleMenu() {
    const body = document.querySelector('body');
    if (body) {
      body.classList.toggle('sidebar-main');
    }
  }

  shoppingCart() {
    this.router.navigate(['/shopping-cart'], {
      state: { tableId: this.tableID },
    });
  }

  logout() {
    this.sharedService.clearFilterState();
    this._auth.clearToken();
  }


  filterLanguage: any;
  getlang() {
    this._api.getLangBasedOnRest().subscribe(lang => {
      this.filterLanguage = lang.languageList
    })
  }

  LanguageFilter(data: any) {
    this._api.passValue(data.target.value);
    localStorage.setItem('languageFilter', data.target.value);
  }
  isOff: any;
  alertMessage:any=''
  restaurantOffOn(data:any) {
    this.openAlertModal();
    if (data=="on") {
      this.isOff = "off";
      this.alertMessage=`Restaurant successfully ${this.isOff}`
    }
    else {
      this.isOff = "on"
      this.alertMessage=`Restaurant successfully ${this.isOff}`
    }
    let formData = {
      "RestId": localStorage.getItem('restaurantId'),
      "status": this.isOff
    }

    this._api.getUpdateRestStatus(formData).subscribe((data: any) => {
      this.aboutMe()
    });
  }

}
